var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22457_41253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.5 0.5C37.65 0.5 48.352 11.132 48.488 24.25C48.488 24.166 48.5 24.084 48.5 24C48.5 10.766 37.734 0 24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 24.084 0.512 24.166 0.512 24.25C0.648 11.132 11.352 0.5 24.5 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.5 47.5C11.35 47.5 0.648 36.868 0.512 23.75C0.512 23.834 0.5 23.916 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 23.916 48.488 23.834 48.488 23.75C48.352 36.868 37.648 47.5 24.5 47.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 24.5,
    cy: 24,
    r: 10,
    transform: "rotate(180 24.5 24)",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0018 14.4425C35.3096 14.7196 35.3346 15.1938 35.0575 15.5017L26.3199 25.0991C25.3454 26.1819 23.6955 26.3168 22.5579 25.4068L19.0315 22.5857C18.7081 22.3269 18.6556 21.8549 18.9144 21.5315C19.1731 21.208 19.6451 21.1556 19.9685 21.4144L23.495 24.2355C24.012 24.6492 24.762 24.5878 25.205 24.0956L33.9426 14.4983C34.2197 14.1904 34.6939 14.1654 35.0018 14.4425Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "url(#paint0_linear_22457_41253)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22457_41253",
    x1: 2.75,
    y1: 13.858,
    x2: 46.25,
    y2: 34.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22457_41253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circle-question.7dd7d8fb.svg";
export { ForwardRef as ReactComponent };